'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _tagDetailsModal = require('../tag-details-modal');

var _tagDetailsModal2 = _interopRequireDefault(_tagDetailsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
  var _state$tags$contentTa = state.tags.contentTagDetails,
      contentTagDetails = _state$tags$contentTa === undefined ? {} : _state$tags$contentTa;
  var communityContentIdObject = ownProps.communityContentIdObject;
  var communityContentType = communityContentIdObject.type,
      communityContentRelatedId = communityContentIdObject.relatedId;


  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var _ref = contentTagDetails[communityContentIdKey] || {},
      _ref$tagDetails = _ref.tagDetails,
      tagDetails = _ref$tagDetails === undefined ? {} : _ref$tagDetails;

  var currentUser = state.userDetails.currentUser;
  var currentUserDetails = currentUser.details;


  return {
    currentUserDetails: currentUserDetails,
    tagDetails: tagDetails
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_tagDetailsModal2.default);